// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__D3lZo","title":"AfterFrontImage_title__19MhS"};